module.exports = __webpack_public_path__ + "static/media/alert_success.ba07a0f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/alert_success.svg
// module id = 819
// module chunks = 0